/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2024-01-01 20:07:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-01-09 19:15:32
 * @FilePath: \baishu_react_ui\src\components\BsyForm\SubmitAnimation.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import './index.css';
import { Component } from 'react';
import BsyIconBtn from '../BsyIconBtn';
import { BsyUtils } from '../../utils/Utils';

export default class SubmitAnimation extends Component {



    constructor(props) {
        super(props)

        //公式联动执行 等待超时时间
        this.asyncCalculatCheckTime = 1000;
        this.asyncCalculatTimeout = 10 * this.asyncCalculatTimeout;
        if('msgbase' in props) {
            this.msgbase = props.msgbase;
        } else {
            this.msgbase = React.language('data.submit.c.base');
        }

        this.state = {
            rowRely: props.rowRely,
            msg: this.msgbase + React.language('data.submit.c.zhong'),
            waitTime: 0,
            process: 1,
        }


    }

    componentDidMount() {
        this.setTimeHandler = setInterval(() => {
            this.showMessage();
        }, this.asyncCalculatCheckTime);
    }

    componentWillUnmount() {
        this.setTimeHandler && clearInterval(this.setTimeHandler);
    }

    showMessage = () => {
        const { process, rowRely, waitTime, msg } = this.state;
        let obj = {
            process: process + (process >= 9 ? 0 : 1),
            msg: this.msgbase,
            waitTime: waitTime + this.asyncCalculatCheckTime
        };

        if (rowRely.ajaxLoading) {
            obj.msg = this.msgbase + rowRely.ajaxLoadingMsg;
            this.setState(obj)
            return false;
        }

        if (rowRely.rely.checkAsyncState(true)) {


            if (rowRely.rely.checkAsyncState(false, true)) {
                this.setTimeHandler && clearInterval(this.setTimeHandler);
                this.setTimeHandler = null;
                obj.process = 10;
                this.setState(obj, () => {
                    this.props.onSubmit && this.props.onSubmit();
                })

                return true;
            } else {

                if (rowRely.rely.isAsyncCalculating()) {
                    let lables = [];
                    let args = rowRely.rely.asyncConcurrentQue.concat(rowRely.rely.asyncTodoQue);
                    for (let i = 0; i < args.length; i++) {
                        let item = args[i];
                        let str = BsyUtils.stringSlice(item.widget.label, 15)
                        lables.push(`「${str}」`)
                    }
                    obj.msg = this.msgbase + lables.join('、');
                } else {
                    if (rowRely.rely.errorField) {
                        let widget = null;
                        if (rowRely.rely.errorField.row) {
                            widget = rowRely.getField(rowRely.rely.errorField.path, rowRely.rely.errorField.row)
                        } else {
                            widget = rowRely.getField(rowRely.rely.errorField.path)
                        }
                        if(widget)
                            obj.msg = this.msgbase + `「${widget.label}」`;
                    }
                }
                this.setState(obj)
                return false;
            }
        } else {
            this.setState(obj)
        }

    }

    render() {
        const { process, msg, waitTime } = this.state;

        return (
            <div className='bsy-show-message-pane'>
                <div className='bsy-show-message-pane-content'>
                    <div className='bsy-show-message-pane-content-timeout'
                        style={{ display: waitTime > this.asyncCalculatTimeout ? 'block' : 'none' }}  >
                        <span>{React.language('data.submit.c.timeout.tip')}</span>
                    </div>
                    <div className='bsy-show-message-pane-content-process'>
                        <div className='bsy-show-message-pane-content-process-bar' style={{ width: `${process}0%` }}></div>
                    </div>
                    <div className='bsy-show-message-pane-content-title'>
                        <span>{msg}</span>
                    </div>
                    <div className='bsy-show-message-pane-content-footer'>
                        <BsyIconBtn
                            text={React.language('cancel')}
                            type="white"
                            click={e => {
                                this.props.onCancel && this.props.onCancel();
                            }}
                            mode={window.mode}

                        ></BsyIconBtn>
                    </div>
                </div>

            </div>
        )
    }
}
